import { request } from './api';

export type UserRole = 'doctor' | 'admin';

export interface AuthUser {
  id: string;
  email: string;
  full_name: string | null;
  role: UserRole;
  is_active: boolean;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: 'bearer';
  user: AuthUser;
}

export function loginUser(email: string, password: string) {
  return request<LoginResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export function getCurrentUser(token: string, skipAuthRefresh = false) {
  return request<AuthUser>('/auth/me', {
    method: 'GET',
    token,
    skipAuthRefresh,
  });
}

export function refreshUserSession(refreshToken: string) {
  return request<LoginResponse>('/auth/refresh', {
    method: 'POST',
    body: JSON.stringify({ refresh_token: refreshToken }),
    skipAuthRefresh: true,
  });
}

export function renewUserSession(accessToken: string) {
  return request<LoginResponse>('/auth/renew', {
    method: 'POST',
    token: accessToken,
    skipAuthRefresh: true,
  });
}
